<script>

    export let projectUpdateSettings = () => {};
    export let projectSettings;

    import {saveSettings, loadSettings} from '../lib/local-storage';
    import FormField from '@smui/form-field';
    import Slider from '@smui/slider';
    import { Label } from '@smui/common';
    import Accordion, { Panel, Header, Content } from '@smui-extra/accordion';
    import Textfield from '@smui/textfield';
    import HelperText from '@smui/textfield/helper-text';
    import Button, { Group } from '@smui/button';
    import Switch from '@smui/switch';

    let outputSizes = [320, 640, 1280];

    let settings = {};
    let imagesToGenerate;
    let outputDimensionWidth;
    let outputDimensionHeight;
    let minZoom;
    let maxZoom;
    
    let basemaps = [];
    let basemapsSelected = [];
    
    const update = () => {
        settings = loadSettings();
        imagesToGenerate = settings.output.imagesToGenerate;
        outputDimensionWidth = settings.outputDimension[0];
        outputDimensionHeight = settings.outputDimension[1];
        minZoom = settings.output.minZoom;
        maxZoom = settings.output.maxZoom;

        // ---
        basemaps = settings.basemaps;
        basemapsSelected = settings.output.basemapsSelected;
    }

    const saveLocalSettings = () => {
        saveSettings(settings)
        if(typeof projectUpdateSettings === 'function') {
            projectUpdateSettings();
        }
    }
    const setImagesToGenerate = () => {
        if(settings.output.imagesToGenerate === imagesToGenerate) return;
        settings.output.imagesToGenerate = imagesToGenerate;
        saveLocalSettings();
        
    }
    const setOutputDimensionWidth = (newWidth) => {
        if(settings.outputDimension[0] === newWidth) return;
        settings.outputDimension[0] = newWidth;
        saveLocalSettings();
        
    }
    const setOutputDimensionHeight = (newHeight) => {
        if(settings.outputDimension[1] === newHeight) return;
        settings.outputDimension[1] = newHeight;
        saveLocalSettings();
    }
    const setZoom = (minZoom, maxZoom) => {
        console.log('setZoom');
        settings.output.minZoom = minZoom;
        settings.output.maxZoom = maxZoom;
        saveLocalSettings();
    }
    const _saveSelection = (basemap, e) => {
        console.log(basemap, e.detail.selected);

        const key = settings.output.basemapsSelected.findIndex(item => item.id === basemap.id);
        if(key === -1) {
            settings.output.basemapsSelected.push(basemap)
        }else{
            settings.output.basemapsSelected.splice(key, 1);
        }

        saveLocalSettings();
    }
    update()
    $: [
        update(projectSettings),
        setImagesToGenerate(imagesToGenerate)
    ]
</script>
{#if settings.output}
<Accordion multiple>
    <!--<Panel extend>
        <Header>
            Image Start Index
            <span slot="description">{downloadCount}</span>
        </Header>
      <Content>
            <Textfield bind:value={downloadCount} label="#" type="number">
                <HelperText slot="helper">File name of the output be like: image_z18_#.jpg & image_z18_#.txt</HelperText>
            </Textfield>
      </Content>
    </Panel>-->
    <Panel>
        <Header>
            Output Dimensions
            <span slot="description">{outputDimensionWidth}px x {outputDimensionHeight}px</span>
        </Header>
      <Content>
        <FormField class="ge-column">
            <div>
                Width:<br/>
                <Group variant="outlined">
                    {#each outputSizes as size}
                        <Button on:click={() => setOutputDimensionWidth(size)} variant="outlined"  color={outputDimensionWidth === size ? 'primary' : 'secondary'}>
                            <Label>{size} px</Label>
                        </Button>
                    {/each}
                </Group>
            </div>
            <div class="ge-margin">x</div>
            <div>
                Height:<br/>
                <Group variant="outlined">
                    {#each outputSizes as size}
                        <Button on:click={() => setOutputDimensionHeight(size)} variant="outlined"  color={outputDimensionHeight === size ? 'primary' : 'secondary'}>
                            <Label>{size} px</Label>
                        </Button>
                    {/each}
                </Group>
            </div>
        </FormField>
      </Content>
    </Panel>
    <Panel>
        <Header>
            Zoom level
            <span slot="description">From {minZoom} to {maxZoom}</span>
        </Header>
      <Content>
       
            <Slider
                range
                on:SMUISlider:input={(e) => setZoom(minZoom, maxZoom)}
                bind:start={minZoom}
                bind:end={maxZoom}
                min={4}
                max={21}
                step={1}
                input$aria-label="Zoom level"
            />
        </Content>
    </Panel>
    <Panel>
        <Header>
            Basemap
            <span slot="description">{settings.output.basemapsSelected.length}</span>
        </Header>
        <Content>
            <div>
                {#each basemaps as basemap}
                    <div class="ge-row">
                        <div class="ge-row">
                            <Label>{basemap.name}</Label>
                        </div>
                        <div>
                            <Switch
                                on:SMUISwitch:change={(e) => _saveSelection(basemap, e)}
                                checked={settings.output.basemapsSelected.findIndex(item => item.id === basemap.id) !== -1}
                                label={basemap.name}
                            />
                        </div>
                    </div>
                {/each}
            </div>
        </Content>
    </Panel>
</Accordion>
{/if}